import React from 'react'

import CompactTokensListItem from '@src/pages/Exchange/components/SelectTokenModal/components/CompactTokensListItem'
import { IToken } from '@src/types/token'

interface CompactTokensListProps {
    tokens: IToken[]
    selectedToken?: IToken
    onTokenClicked: (token: IToken) => void
    getTokenBalance?: (token: IToken) => { tokenBalance: string; usdBalance: string } | undefined
}

export const CompactTokensList: React.FC<CompactTokensListProps> = ({
    tokens,
    selectedToken,
    onTokenClicked,
    getTokenBalance,
}) => {
    return (
        <div className='space-y-0.5'>
            {tokens.map(token => {
                const balance = getTokenBalance?.(token)

                return (
                    <CompactTokensListItem
                        key={`${token.chainId}-${token.address}`}
                        selectedToken={selectedToken}
                        token={token}
                        onTokenClicked={onTokenClicked}
                        userBalanceInTokens={balance?.tokenBalance}
                        userBalanceInUsd={balance?.usdBalance}
                    />
                )
            })}
        </div>
    )
}

export default CompactTokensList
